import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressMeterService {
  public meter$ = new BehaviorSubject<boolean>(false);

  public changeStatus(status: boolean): void {
    this.meter$.next(status);
  }
}
